import styled from "@emotion/styled";
import { Spacing } from "@snapchat/snap-design-system";

export const Container = styled.div`
    padding: ${Spacing.MD}px;
`;
